import { partial } from 'superstruct';

import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewKeywordDto } from './keyword.dto';

const KeywordSortableFields: (keyof ViewKeywordDto)[] = [
	'id',
	'name',
	'createdAt',
	'updatedAt',
	'type',
	'list',
] as const;

export const DEFAULT_KEYWORD_SORT = 'createdAt';
export const DEFAULT_KEYWORD_SORT_DIR = 'desc';

export const ListKeywordSort = partial(
	SortQueryDefaulted(
		KeywordSortableFields,
		DEFAULT_KEYWORD_SORT,
		DEFAULT_KEYWORD_SORT_DIR
	)
);
